export const columns = [
  {
    title: '编号',
    dataIndex: 'id',
  },
  {
    title: '计划名称',
    dataIndex: 'title',
  },
  {
    title: '发起方',
    dataIndex: 'qichacha_name1',
  },
  {
    title: '执行方',
    dataIndex: 'qichacha_name2',
  },
  // {
  //   title: '关联产品',
  //   dataIndex: 'link_products',
  // },
  {
    title: '服务地区',
    dataIndex: 'location',
  },
  {
    title: '开始时间',
    dataIndex: 'service_start_time',
  },
  {
    title: '结束时间',
    dataIndex: 'service_end_time',
  },
  {
    title: '协议状态',
    dataIndex: 'status',
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    width: 150,
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  },
];

export const formData1 = [
  {
    name: 'name',
    lable: '发起方',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'service_provider_id',
    lable: '执行方',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'title',
    lable: '计划名称',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'service_time',
    lable: '推广期限',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  // {
  //   name: 'link_products',
  //   lable: '关联产品',
  //   lableCol: 5,
  //   wrapperCol: 17,
  //   offset: 0,
  //   span: 12,
  // },
  // {
  //   name: 'datas',
  //   lable: '关联资料',
  //   lableCol: 5,
  //   wrapperCol: 17,
  //   offset: 0,
  //   span: 12,
  // },
  {
    name: 'money',
    lable: '推广预算',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  {
    name: 'province_city',
    lable: '推广区域',
    lableCol: 5,
    wrapperCol: 17,
    offset: 0,
    span: 12,
  },
  
];

export const formData2 = [
  {
    name: 'type',
    lable: '',
    span: 24,
    lableCol: 0,
    wrapperCol: 24,
    offset: 0,
  },
];
export const formData3 = [
  {
    name: 'flag',
    lable: '',
    span: 24,
    lableCol: 0,
    wrapperCol: 24,
    offset: 0,
  },
  {
    name: 'desc',
    lable: '',
    span: 24,
    lableCol: 0,
    wrapperCol: 24,
    offset: 0,
  },
];
